import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function TaskSubCategoriesReducer(
	state = initialState.taskSubCategories,
	action
) {
	switch (action.type) {
		case types.GET_TASK_SUBCATEGORIES: {
			return [
				{
					id: 1,
					count: action.response.totalCount || 0
				},
				{
					id: 2,
					count: action.response.toPrepareCount || 0
				},
				{
					id: 3,
					count: action.response.forReviewCount || 0
				}
			];
		}
		case types.UPDATE_TASK_SUBCATEGORIES: {
			return [
				{
					id: 1,
					count: action.data.totalCount || 0
				},
				{
					id: 2,
					count: action.data.toPrepareCount || 0
				},
				{
					id: 3,
					count: action.data.forReviewCount || 0
				}
			];
		}
		case types.TASK_LIST_LOADED: {
			return [
				{
					id: 1,
					count: action.taskList.totalCount || 0
				},
				{
					id: 2,
					count: action.taskList.toPrepareCount || 0
				},
				{
					id: 3,
					count: action.taskList.forReviewCount || 0
				}
			];
		}
		case types.CLEAR_TASK_SUBCATEGORIES: {
			return [];
		}
		case types.RESET_TASK_CATEGORY: {
			return [];
		}
		default:
			return state;
	}
}
